import { useState, useEffect } from 'react';
import '../dashboard/css/core.css';
import '../dashboard/css/theme-default.css';
import '../dashboard/css/demo.css';
import '../dashboard/libs/perfect-scrollbar/perfect-scrollbar.css';
import '../dashboard/libs/apex-charts/apex-charts.css';
import '../dashboard/js/helpers';
import '../dashboard/js/config';
import '../dashboard/fonts/boxicons.css';
import '../dashboard/css/icons.css';
import '../dashboard/menuisidebar.css';
import avatar from '../dashboard/img/avatars/1.png';
import icone from '../dashboard/img/icons/brands/contrato_de_propriedade.png';
import LocalStorage from '../../helpers/localstorage';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { setupAPIclient } from '../../services/setupAPIclient';
import PhoneInput from 'react-phone-input-2';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { BsChevronLeft, BsChevronRight, BsBoxArrowRight, BsUpload, BsPerson, BsBell, BsBarChart, BsClockHistory } from "react-icons/bs";
import { BiMenu } from "react-icons/bi";
import { FiAward } from 'react-icons/fi';

interface LayoutProps {
  children: React.ReactNode;
}

type Country = {
  name: string;
  code: string;
  flag: string;
};

const Layout: React.FC<LayoutProps> = ({ children }) => {

  const localStorage = new LocalStorage();
  const navigate = useNavigate();

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [showModalUpdateSubmaster, setShowModalUpdateSubmaster] = useState(false);
  const [isPermissionGranted, setPermissionGranted] = useState(false);

  const [isCadastroOpen, setCadastroOpen] = useState(false);
  const [isContractOpen, setContractOpen] = useState(false);

  const [countries, setCountries] = useState<Country[]>([]);
  const [selectedCountry, setSelectedCountry] = useState('');

  const [preview, setPreview] = useState<string | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    number_phone: "",
    city: "",
    //country: "",
    imagecompany_logo: "",
     cod_pix: '',
    cartao_credit: {
      numerocredito: '',
      cvv: '',
      nome: '',
      validade: '',
    },
    due_date: '',
    features: []
  });

  // Toggle lateral menu
  const toggleMenu = () => setIsCollapsed(!isCollapsed);

  // Logout
  const logout = () => {
    localStorage.removeAuthToken();
    navigate("/");
  };

  // Handle input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({...formData, [e.target.name]: e.target.value});
  };

  // Handle file selection
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if(file){
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result as string);
      reader.readAsDataURL(file);
    } else {
      setSelectedFile(null);
      setPreview(null);
    }
  };

  // Fetch countries
  const handleGetCountries = async () => {
    try {
      const res = await fetch("https://restcountries.com/v3.1/all?fields=name,flags,cca2");
      const data = await res.json();
      const list = data.map((c: any) => ({
        name: c.name.common,
        code: c.cca2,
        flag: c.flags.png
      })).sort((a: Country, b: Country) => a.name.localeCompare(b.name));
      setCountries(list);
    } catch (err) {
      console.error("Erro ao buscar países", err);
    }
  };

  // Handle country select
  const handleChangeCountry = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedCountry(e.target.value);
    setFormData({...formData, country: e.target.value});
  };

  // Fetch user data
  const handleGetDataUser = async () => {
    try{
      const token = String(localStorage.getAuthToken());
      const ApiClient = setupAPIclient(token);
      const response = await ApiClient.post("/auth/get/login");
      setFormData(prev => ({...prev, ...response.data}));
      setSelectedCountry(response.data.country || "");
    } catch(error){ console.error(error); }
  };

  // Submit update
  const handleSubmitUpdate = async (e: React.FormEvent) => {
    e.preventDefault();

    // country
    
    const requiredFields = ["name", "email", "city"];
    for(const field of requiredFields){
      if(!String((formData as any)[field]).trim()){
        toast.error(`O campo ${field} é obrigatório!`, { autoClose: 2000 });
        return;
      }
    }

    const token = String(localStorage.getAuthToken());
    const ApiClient = setupAPIclient(token);
    const toastId = toast.loading("Atualizando dados...");

    try{
      
      const fd = new FormData();
      // Object.keys(formData).forEach(key => fd.append(key, (formData as any)[key]));


      // Adiciona apenas campos exceto email
      Object.keys(formData)
      .filter(key => key !== "due_date") // <-- remove email
      .filter(key => key !== "activate_plan") // <-- remove email
      .filter(key => key !== "payment_date") // <-- remove email
      .filter(key => key !== "plan_key") // <-- remove email
      .filter(key => key !== "features") // <-- remove email
      .forEach(key => fd.append(key, (formData as any)[key]));

      const fileInput = document.getElementById("imagecompany_logo") as HTMLInputElement;
      if(fileInput?.files?.[0]) fd.append("imagecompany_logo", fileInput.files[0]);

      const response = await ApiClient.post("/auth/register/update", fd, { headers: { "Content-Type": "multipart/form-data" } });

      if(response.data.error){
        toast.update(toastId, { render: "Por favor digite outro e-mail", type:"warning", isLoading:false, autoClose:1000 });
      } else {
        toast.update(toastId, { render: "Dados atualizados com sucesso!", type:"success", isLoading:false, autoClose:1000, onClose: () => window.location.reload() });
      }

    } catch(error){
      toast.update(toastId, { render: "Erro ao atualizar os dados", type:"error", isLoading:false, autoClose:2000 });
    }
  };


  function escolherCidade(formData:any) {
    const opcoes = [
      { code: "BR", label: "BR — Brasil" },
      { code: "US", label: "US — United States" },
      { code: "PT", label: "PT — Portugal" },
    ];

    return (
      <select
        name="city"
        value={formData.city}
        onChange={(e) => setFormData({ ...formData, city: e.target.value })}
        style={{ 
          ...inputStyle, 
          cursor: "pointer", 
          appearance: "none", 
          backgroundColor: "white" 
        }}
      >
        <option value="" disabled>Escolher pais</option>
        {opcoes.map((o) => (
          <option key={o.code} value={o.label}>
            {o.label}
          </option>
        ))}
      </select>
    );
  }

// ---------- Paleta de cores ----------
const colors = {
  darkGray: "#7A7A7A",        
  
};
  // ---------- Estilos Globais ----------
const inputWrapperStyle = {
  display: "flex",
  alignItems: "center",
  border: `1px solid ${colors.darkGray}`,
  borderRadius: "10px",
  padding: "8px 12px",
  background: "#fff",
  gap: "10px",
};
const inputStyle = { border: "none", outline: "none", flex: 1, fontSize: "16px", color: colors.darkGray };


  useEffect(() => {
    handleGetDataUser();
    handleGetCountries();
  }, []);

  /**
   * Palette used:
   * Branco: #FFFFFF
   * Cinza claro: #F5F6FA (fallback #EDEDED)
   * Cinza escuro (text-muted): #7A7A7A
   * Preto suave (text): #222222
   * Azul claro (icons/links): #4A90E2
   * Vermelho rosado (buttons/indicators): #E74C3C (hover #FF5A5F)
   * Rosa magenta (highlights): #FF2E93 (accent #C94DDB)
   */

  const dueDateNumber = Number(formData.due_date);
  const isPlanCanceled = !isNaN(dueDateNumber) && dueDateNumber < 0;

  return (
    <div className="layout-wrapper layout-content-navbar centerLayout" style={{ background: "#FFFFFF", color: "#222222" }}>
      <div className="layout-container">
        {/* Sidebar */}
        {!isCollapsed && (
          <aside
              className="layout-menu menu-vertical d-flex flex-column"
              style={{
                background: "#F5F6FA", // cinza claro (sidebar)
                minHeight: "100vh",
                width: isCollapsed ? "70px" : "250px",
                transition: "width 0.3s",
                color: "#222222",
                paddingTop: "1rem",
                borderRight: "1px solid #EDEDED"
              }}
            >
          {/* Brand / Logo */}
          <div
            className="app-brand d-flex align-items-center justify-content-between px-3 mb-4"
            style={{ borderBottom: "1px solid rgba(34,34,34,0.06)", paddingBottom: "1rem" }}
          >
            {!isCollapsed && (
              <div className="d-flex align-items-center">
                <img
                  src={`https://alexios.com.br:9598/uploads/logo/${formData.imagecompany_logo}`}
                  className="rounded-circle"
                  width={45}
                  height={45}
                  alt="Perfil"
                />
                <span className="ms-2 fw-bold" style={{ color: "#222222", fontSize: "1.1rem" }}>
                  Acesso Adm
                </span>
              </div>
            )}
            <button
              onClick={toggleMenu}
              className="btn btn-light btn-sm"
              style={{
                color: "#222222",
                background: "#FFFFFF",
                border: "1px solid #EDEDED"
              }}
              aria-label="Toggle menu"
            >
              {isCollapsed ? <BsChevronRight color="#4A90E2" /> : <BsChevronLeft color="#4A90E2" />}
            </button>
          </div>

          {/* Menu Items */}
          <ul className="menu-inner list-unstyled px-2">


             <li className="menu-item mb-1">
                <Link
                  to="/HomePage"
                  className="menu-link d-flex align-items-center p-2 rounded"
                  style={{ color: "#222222", transition: "all 0.3s", textDecoration: 'none' }}
                  title="Página inicial do sistema"
                >
                  <span
                    className="me-2 fs-5 d-flex align-items-center justify-content-center"
                    style={{
                      transition: "transform 0.3s, color 0.3s",
                    }}
                  >
                   <BsBoxArrowRight color="#4A90E2" />
                  </span>
                  {!isCollapsed && <span style={{ color: "#222222" }}>Inicio</span>}
                </Link>
              </li>

            {/** Contrato */}
            <li className="menu-item mb-1">
              <div
                onClick={() => setContractOpen(!isContractOpen)}
                className="menu-link d-flex align-items-center p-2 rounded"
                style={{ cursor: "pointer", color: "#222222", transition: "all 0.3s" }}
                title="Gerenciar contratos"
              >
                <span
                  className="me-2 fs-5 d-flex align-items-center justify-content-center"
                  style={{ transition: "transform 0.3s, color 0.3s" }}
                >
                  <BsUpload color="#4A90E2" />
                </span>
                {!isCollapsed && <span style={{ color: "#222222" }}>C. contrato</span>}
              </div>
              {isContractOpen && !isCollapsed && (
                <ul className="submenu list-unstyled ps-4 mt-1">
                  <li>
                    <Link
                      to="/UploadPage"
                      className="menu-link d-block p-2 rounded"
                      style={{ fontSize: "0.9rem", background: "transparent", transition: "all 0.3s", color: "#222222" }}
                    >
                      Upload contrato
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/SeeContractPage"
                      className="menu-link d-block p-2 rounded"
                      style={{ fontSize: "0.9rem", background: "transparent", transition: "all 0.3s", color: "#222222" }}
                    >
                      Ver contratos
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/** Cadastro */}
            <li className="menu-item mb-1">
              <div
                onClick={() => setCadastroOpen(!isCadastroOpen)}
                className="menu-link d-flex align-items-center p-2 rounded"
                style={{ cursor: "pointer", color: "#222222", transition: "all 0.3s" }}
                title="Cadastro de regiões, unidades e locais"
              >
                <span
                  className="me-2 fs-5 d-flex align-items-center justify-content-center"
                  style={{ transition: "transform 0.3s, color 0.3s" }}
                >
                  <BsPerson color="#4A90E2" />
                </span>
                {!isCollapsed && <span style={{ color: "#222222" }}>Cadastro</span>}
              </div>
              {isCadastroOpen && !isCollapsed && (
                <ul className="submenu list-unstyled ps-4 mt-1">
                  <li>
                    <Link
                      to="/UserPage"
                      className="menu-link d-block p-2 rounded"
                      style={{ fontSize: "0.9rem", background: "transparent", transition: "all 0.3s", color: "#222222" }}
                    >
                      C.Usuário
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/CompanyPage"
                      className="menu-link d-block p-2 rounded"
                      style={{ fontSize: "0.9rem", background: "transparent", transition: "all 0.3s", color: "#222222" }}
                    >
                      C.Empresa
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/RegionForm"
                      className="menu-link d-block p-2 rounded"
                      style={{ fontSize: "0.9rem", background: "transparent", transition: "all 0.3s", color: "#222222" }}
                    >
                      C.Região
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/UnitForm"
                      className="menu-link d-block p-2 rounded"
                      style={{ fontSize: "0.9rem", background: "transparent", transition: "all 0.3s", color: "#222222" }}
                    >
                      C.Unidade
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/LocalForm"
                      className="menu-link d-block p-2 rounded"
                      style={{ fontSize: "0.9rem", background: "transparent", transition: "all 0.3s", color: "#222222" }}
                    >
                      C.Local
                    </Link>
                  </li>
                </ul>
              )}
            </li>

          
            {[
              { to: "/NotificationPage", icon: <BsBell color="#4A90E2" />, label: "Notificação", title: "Notificações do sistema" },
              { to: "/ReportPage", icon: <BsBarChart color="#4A90E2" />, label: "Relatórios", title: "Relatórios do sistema" },
              { to: "/PlanSubmasterPage", icon: <BsBoxArrowRight color="#4A90E2" />, label: "Financeiro", title: "Financeiro" },
              { 
                to: "/HistoryPage", 
                icon: <BsClockHistory color="#4A90E2" />, 
                label: "Histórico P.", 
                title: "Histórico P." 
              },

            ].map((item, idx) => (
              <li className="menu-item mb-1" key={idx}>
                <Link
                  to={item.to}
                  className="menu-link d-flex align-items-center p-2 rounded"
                  style={{ color: "rgba(34, 34, 34, 1)", transition: "all 0.3s", textDecoration: 'none' }}
                  title={item.title}
                >
                  <span
                    className="me-2 fs-5 d-flex align-items-center justify-content-center"
                    style={{
                      transition: "transform 0.3s, color 0.3s",
                    }}
                  >
                    {item.icon}
                  </span>
                  {!isCollapsed && <span style={{ color: "#222222" }}>{item.label}</span>}
                </Link>
              </li>
            ))}


          
         
          </ul>

          {/* CSS para animação de hover */}
          <style>
            {`
              .menu-link:hover span:first-child {
                transform: scale(1.2);
                color: #4A90E2 !important;
              }
              .menu-link:hover {
                background: rgba(74,144,226,0.06);
              }
              /* collapsed small icon style */
              .layout-menu .fs-5 svg {
                display: block;
              }
            `}
          </style>
          </aside>
        )}

        {/* Page Wrapper */}
        <div className="layout-page" style={{ background: "#FFFFFF" }}>
          {/* Navbar */}
         <nav
  className="ml-2 mr-2 mt-2 navbar navbar-expand-lg shadow-sm rounded-4 px-4 py-2"
  style={{
    background: "#FFFFFF", // navbar branco primário
    color: "#222222",
    border: "1px solid #EDEDED"
  }}
>
  <div className="d-flex align-items-center flex-grow-1">
    <button
      className="btn me-3 rounded-circle p-2"
      onClick={toggleMenu}
      style={{
        minWidth: '45px',
        minHeight: '45px',
        background: "#E74C3C", // vermelho rosado primary (button)
        color: "#FFFFFF",
        border: "none",
        transition: "background 0.15s",
      }}
      onMouseEnter={e => (e.currentTarget.style.background = "#FF5A5F")}
      onMouseLeave={e => (e.currentTarget.style.background = "#E74C3C")}
      aria-label="Abrir menu"
    >
      <BiMenu size={24} color="#FFFFFF" />
    </button>
  </div>

  <ul className="navbar-nav ms-auto d-flex align-items-center">
    <li className="nav-item dropdown">
      <a
        className="nav-link dropdown-toggle d-flex align-items-center"
        data-bs-toggle="dropdown"
        href="#"
        style={{ color: "#222222" }}
      >
        <img
          src={`https://alexios.com.br:9598/uploads/logo/${formData.imagecompany_logo}`}
          className="rounded-circle"
          style={{ border: "2px solid #EDEDED" }}
          width={45}
          height={45}
          alt="Perfil"
        />
      </a>
      <ul
        className="dropdown-menu dropdown-menu-end shadow rounded-3"
        style={{ background: "#FFFFFF", color: "#222222", border: "1px solid #EDEDED" }}
      >
        <li>
          <span className="dropdown-item-text fw-bold" style={{ color: "#222222" }}>
            {formData.name}
          </span>
        </li>
        <li>
          <button
            className="dropdown-item"
            onClick={() => setShowModalUpdateSubmaster(true)}
            style={{ color: "#222222", transition: "background 0.15s" }}
            onMouseEnter={e => (e.currentTarget.style.background = "rgba(74,144,226,0.06)")}
            onMouseLeave={e => (e.currentTarget.style.background = "transparent")}
          >
            Editar Perfil
          </button>
        </li>
        <li>
          <button
            className="dropdown-item"
            onClick={logout}
            style={{ color: "#222222", transition: "background 0.15s" }}
            onMouseEnter={e => (e.currentTarget.style.background = "rgba(74,144,226,0.06)")}
            onMouseLeave={e => (e.currentTarget.style.background = "transparent")}
          >
            Sair
          </button>
        </li>
      </ul>
    </li>
  </ul>
          </nav>

          <style jsx>{`
            .navbar {
              transition: all 0.3s ease;
            }

            .navbar .form-control:focus {
              box-shadow: 0 0 10px rgba(74,144,226,0.18);
              border-color: #4A90E2;
            }

            .dropdown-menu {
              min-width: 200px;
            }

            .dropdown-item:hover {
              background-color: rgba(74,144,226,0.08);
              color: #222222;
            }
            .text-muted { color: #7A7A7A !important; }
          `}</style>

          {/* Content */}
          <div className="content p-4" style={{ background: "#FFFFFF" }}>
           
          <div
            className="d-flex align-items-center rounded-3 shadow-sm p-3 mb-4"
            style={{
              backgroundColor: "#FFFFFF", // fundo branco para destacar
              border: "1px solid #EDEDED",
            }}
          >

              {/* NOVO: alerta para plano cancelado por pagamento devedor */}
              
            {/* Ícone em círculo colorido */}
            <div
              className="d-flex align-items-center justify-content-center rounded-circle me-3"
              style={{
                backgroundColor: "#FF2E93",
                width: "48px",
                height: "48px",
              }}
            >
              <FiAward size={24} color="#FFFFFF" />
            </div>

            {/* Texto */}
            <div>

                {isPlanCanceled ? (
                  <div className="alert alert-danger d-flex align-items-center" role="alert">
                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                    <div>
                      <strong>Plano cancelado:</strong>
                       existe um pagamento em atraso. O plano foi cancelado devido
                      a um débito pendente. Por favor, regularize o pagamento para reativar o plano.
                    </div>
                  </div>
                ) :               <div style={{ fontSize: "0.9rem", color: "#7A7A7A" }}>Plano atual</div>}
                

              <div>
                <span className="fw-bold" style={{ color: "#4A90E2" }}>
                      <span>{formData?.features[0]?.plan}</span>
                </span>
                <span style={{ color: "#7A7A7A" }}> · </span>
                <span className="fw-bold" style={{ color: "#222222" }}>{formData.due_date} /  dias</span>
              </div>
            </div>
          </div>


            {children}
          </div>

          {/* Footer */}
          <footer className="bg-light py-3 text-center" style={{ background: "#F5F6FA", color: "#7A7A7A" }}>© 2025</footer>
        </div>
      </div>

        {/* Modal Editar Perfil */}
        {showModalUpdateSubmaster && (
          <div className="modal fade show d-block" tabIndex={-1}>
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content border-0 rounded-4 shadow-lg">

      {/* Cabeçalho */}
      <div
        className="modal-header rounded-top-4 d-flex align-items-center justify-content-between"
        style={{ background: "#E74C3C", color: "#FFFFFF" }}
      >
        <h5 className="modal-title d-flex align-items-center fw-bold" style={{color:"#FFFFFF"}}>
          <i className="bi bi-person-lines-fill me-2 animate__animated animate__fadeInLeft"></i>
          Editar Perfil
        </h5>
        <button
          type="button"
          className="btn-close btn-close-white"
          onClick={() => setShowModalUpdateSubmaster(false)}
          aria-label="Fechar"
        />
      </div>

<div
            className="d-flex mt-2 ml-2 mr-2 align-items-center rounded-3 shadow-sm p-3 mb-4"
            style={{
              backgroundColor: "#FFFFFF", // fundo branco para destacar
              border: "1px solid #EDEDED",
            }}
          >
            {/* Ícone em círculo colorido */}
            <div
              className="d-flex align-items-center justify-content-center rounded-circle me-3"
              style={{
                backgroundColor: "#FF2E93",
                width: "48px",
                height: "48px",
              }}
            >
              <FiAward size={24} color="#FFFFFF" />
            </div>

            {/* Texto */}
              <div>

                {isPlanCanceled ? (
                  <div className="alert alert-danger d-flex align-items-center" role="alert">
                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                    <div>
                      <strong>Plano cancelado:</strong>
                       existe um pagamento em atraso. O plano foi cancelado devido
                      a um débito pendente. Por favor, regularize o pagamento para reativar o plano.
                    </div>
                  </div>
                ) :               <div style={{ fontSize: "0.9rem", color: "#7A7A7A" }}>Plano atual</div>}
                

              <div>
                <span className="fw-bold" style={{ color: "#4A90E2" }}>
                      <span>{formData?.features[0]?.plan}</span>
                </span>
                <span style={{ color: "#7A7A7A" }}> · </span>
                <span className="fw-bold" style={{ color: "#222222" }}>{formData.due_date} /  dias</span>
              </div>
            </div>
          </div>
  

      {/* Corpo */}
      <div className="modal-body p-4" style={{ background: "#FFFFFF" }}>
        <div className="d-flex flex-column flex-md-row align-items-center gap-4">

          {/* Avatar */}
          <div className="text-center flex-shrink-0">
            <div className="position-relative d-inline-block avatar-hover">
              <img
                src={`https://alexios.com.br:9598/uploads/logo/${formData.imagecompany_logo}`}
                className="rounded-circle border shadow-sm"
                style={{
                  width: "140px",
                  height: "140px",
                  objectFit: "cover",
                  transition: "all 0.3s",
                  backgroundColor: "#F5F6FA",
                  border: "1px solid #EDEDED"
                }}
                alt="Logo Empresa"
              />
              <label
                htmlFor="imagecompany_logo"
                className="position-absolute bottom-0 end-0 rounded-circle p-2 shadow"
                style={{
                  cursor: "pointer",
                  border: "2px solid #FFFFFF",
                  backgroundColor: "#E74C3C",
                  color: "#FFFFFF",
                }}
                title="Alterar imagem"
              >
                <i className="bi bi-camera-fill animate__animated animate__pulse"></i>
              </label>
              <input
                type="file"
                id="imagecompany_logo"
                accept="image/*"
                className="d-none"
                onChange={handleFileChange}
              />
            </div>
            <small className="d-block mt-2 text-muted">
              Clique no ícone para alterar a imagem
            </small>
          </div>

          {/* Formulário */}
         <form className="flex-grow-1 row g-3" onSubmit={handleSubmitUpdate}>
  <div className="col-md-6">
    <label className="form-label fw-semibold d-flex align-items-center">
      <i className="bi bi-person me-2 animate__animated animate__fadeInLeft" style={{ color: "#4A90E2" }}></i> Nome
    </label>
    <input
      type="text"
      className="form-control shadow-sm"
      name="name"
      placeholder="Nome"
      value={formData.name}
      onChange={handleChange}
      required
      style={{ borderColor: "#EDEDED" }}
    />
  </div>

  <div className="col-md-6">
    <label className="form-label fw-semibold d-flex align-items-center">
      <i className="bi bi-envelope-at me-2 animate__animated animate__fadeInLeft" style={{ color: "#4A90E2" }}></i> Email
    </label>
    <input
      type="email"
      className="form-control shadow-sm"
      name="email"
      placeholder="Email"
      value={formData.email}
      onChange={handleChange}
      disabled
      style={{ borderColor: "#EDEDED" }}
    />
  </div>

  <div className="col-md-6">
    <label className="form-label fw-semibold d-flex align-items-center">
      <i className="bi bi-geo-alt me-2 animate__animated animate__fadeInLeft" style={{ color: "#4A90E2" }}></i> Cidade
    </label>
    {/*<input
      type="text"
      className="form-control shadow-sm"
      name="city"
      placeholder="Cidade"
      value={formData.city}
      onChange={handleChange}
      style={{ borderColor: "#EDEDED" }}
    />*/}
    <div style={inputWrapperStyle}>
      <span style={{ color: colors.red }}>🏙️</span>
      {escolherCidade(formData)}
    </div>
  </div>

  {/*<div className="col-md-6">
    <label className="form-label fw-semibold d-flex align-items-center">
      <i className="bi bi-globe2 me-2 animate__animated animate__fadeInLeft" style={{ color: "#4A90E2" }}></i> País
    </label>
    <select
      className="form-select shadow-sm"
      value={selectedCountry}
      onChange={handleChangeCountry}
      style={{ borderColor: "#EDEDED" }}
    >
      {formData.country ? (
        <option value="country">{formData.country}</option>
      ) : (
        <option value="">Selecione um país</option>
      )}
      {countries.map((c) => (
        <option key={c.name} value={c.name}>
          {c.name}
        </option>
      ))}
    </select>
  </div>*/}
   
  <div className="col-md-12">
    <label className="form-label fw-semibold d-flex align-items-center">
      <i className="bi bi-telephone me-2 animate__animated animate__fadeInLeft" style={{ color: "#4A90E2" }}></i> Telefone
    </label>
    <PhoneInput
      country={"br"}
      enableSearch
      value={formData.number_phone}
      onChange={(value) =>
        setFormData({ ...formData, number_phone: value })
      }
      inputProps={{
        name: "number_phone",
        required: true,
        className: "form-control shadow-sm",
        placeholder: "Número de telefone",
      }}
      inputStyle={{
        width: "100%",
        fontSize: "16px",
        backgroundColor: "#F5F6FA",
        height: "45px",
        border: "1px solid #EDEDED"
      }}
    />
  </div>
</form>

        </div>
      </div>

      {/* Rodapé */}
      <div className="modal-footer rounded-bottom-4 d-flex justify-content-end" style={{ background: "#FFFFFF", borderTop: "1px solid #EDEDED" }}>
        <button
          className="btn d-flex align-items-center me-2"
          onClick={() => setShowModalUpdateSubmaster(false)}
          style={{
            backgroundColor: "#FFFFFF",
            color: "#222222",
            border: "1px solid #EDEDED",
            transition: "background 0.15s",
          }}
          onMouseEnter={e => (e.currentTarget.style.background = "#FF5A5F")}
          onMouseLeave={e => (e.currentTarget.style.background = "#FFFFFF")}
        >
          <i className="bi bi-x-circle me-2 animate__animated animate__fadeIn"></i> Fechar
        </button>
        <button
          className="btn d-flex align-items-center"
          onClick={handleSubmitUpdate}
          style={{
            backgroundColor: "#E74C3C",
            color: "#FFFFFF",
            border: "none",
            transition: "background 0.15s",
          }}
          onMouseEnter={e => (e.currentTarget.style.background = "#FF5A5F")}
          onMouseLeave={e => (e.currentTarget.style.background = "#E74C3C")}
        >
          <i className="bi bi-save me-2 animate__animated animate__pulse"></i> Salvar Alterações
        </button>
      </div>
    </div>
  </div>
</div>

        )}
    </div>
  );
};

export default Layout;
